
'use client';

import Link from 'next/link';

export function Footer() {
    return (
        <footer className="bg-muted/40 border-t mt-16">
            <div className="container py-12">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                    <div className="flex flex-col gap-4">
                        <p className="font-bold tracking-wider uppercase text-sm text-muted-foreground">Company</p>
                        <Link href="/about" className="text-sm hover:underline">About Us</Link>
                        <Link href="/features" className="text-sm hover:underline">Features & Roadmap</Link>
                        <Link href="/membership" className="text-sm hover:underline">Membership</Link>
                    </div>
                    <div className="flex flex-col gap-4">
                        <p className="font-bold tracking-wider uppercase text-sm text-muted-foreground">Explore</p>
                        <Link href="/discover" className="text-sm hover:underline">Discover</Link>
                        <Link href="/artists" className="text-sm hover:underline">Artists</Link>
                         <Link href="/sets" className="text-sm hover:underline">Sets</Link>
                        <Link href="/articles" className="text-sm hover:underline">Articles</Link>
                        <Link href="/blog" className="text-sm hover:underline">Blog</Link>
                        <Link href="/games" className="text-sm hover:underline">Games</Link>
                    </div>
                     <div className="flex flex-col gap-4">
                        <p className="font-bold tracking-wider uppercase text-sm text-muted-foreground">Resources</p>
                        <Link href="/welcome" className="text-sm hover:underline">Welcome Guide</Link>
                        <Link href="/contact" className="text-sm hover:underline">Contact</Link>
                    </div>
                </div>

                <div className="border-t mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-sm text-muted-foreground">
                        &copy; {new Date().getFullYear()} Art Vault. All rights reserved.
                    </p>
                    <div className="flex items-center gap-4">
                        <Link href="/privacy-policy" className="text-sm text-muted-foreground hover:underline">Privacy Policy</Link>
                        <div className="h-4 w-px bg-border" />
                        <Link href="/terms-of-service" className="text-sm text-muted-foreground hover:underline">Terms of Service</Link>
                         <div className="h-4 w-px bg-border" />
                        <Link href="/contact" className="text-sm text-muted-foreground hover:underline">Contact</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
